import { WOODLAND_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/woodlandBackdrops';
import { ATMOSPHERE_PALETTE as P } from '../palette';
import { forestBiome } from '../biomeArchetypes';

/** Meadow — sunlit open grassland: a gentle blue sky with soft drifting cloud bands, a warm high
 *  sun + halo, golden pollen/seed motes, soft sun shafts, a breathing sun-bloom bed, dandelion
 *  seeds streaming on the breeze, a faint grass shimmer, gentle rolling soft-green hills, a light
 *  vignette, and a warm grade. The BRIGHT, airy, peaceful counterpoint to the dark biomes —
 *  contrast kept (no pale wash). */
export const MEADOW = forestBiome({
  id: 'meadow',
  sky: { from: 0x8fc4ec, to: 0xb9e08c },
  celestial: { atX: 0.72, atY: 0.15, color: P.sunHaze, haloColor: 0xffe39a, size: 90, haloScale: 3.0, coreAlpha: 0.82, haloAlpha: 0.2 },
  cloudBands: { count: 5, color: 0xfbf4df, sizeMin: 380, sizeMax: 680, alphaMin: 0.05, alphaMax: 0.13, driftPxPerSec: 6, bandYMin: 0.08, bandYMax: 0.32 },
  motes: { colors: [0xfff6cf, P.leaf, P.firefly], count: 24, alphaMin: 0.18, alphaMax: 0.6 },
  rays: { color: P.sunHaze },
  glow: {
    blobs: [
      { color: P.sunHaze, atX: 0.72, atY: 0.13, size: 440, alpha: 0.08 },
      { color: P.leaf, atX: 0.5, atY: 0.97, size: 600, alpha: 0.07 },
    ],
    breathe: { periodMs: 6500, min: 0.85, max: 1.2 },
  },
  lightField: { palette: [P.sunHaze, P.leaf, P.firefly] },
  weather: { mode: 'fall', color: 0xfdf3d2, colorEnd: 0xdfe9b0, gust: { periodMs: 7500, min: 0.5, max: 1.45, phase: 0.3 } },
  flicker: { color: 0xfff0c0 },
  parallax: [
    { svg: WOODLAND_BACKDROPS.meadow.far, shape: 'dunes', color: 0x9cca73, speed: 0.04, height: 300, alpha: 0.68, detail: 0.7, sway: { ampPx: 8, periodMs: 32000 } },
    { svg: WOODLAND_BACKDROPS.meadow.mid, shape: 'dunes', color: 0x77ab53, speed: 0.10, height: 220, alpha: 0.82, detail: 1.0 },
    { svg: WOODLAND_BACKDROPS.meadow.near, shape: 'ridge', color: 0x55893a, speed: 0.18, height: 150, alpha: 0.92, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x3a5224, edgeAlpha: 0.22, washColor: 0xc0e88a, washAlpha: 0.04 },
    grade: { top: 0xffe9a8, bottom: 0x9fcf6a, strength: 0.1, blend: 'normal' },
  },
});
